'use client';

import Avatar from '@ui/Avatar';
import Card from '@ui/Card';
import Link from '@ui/Link';
import Typography from '@ui/Typography';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { cx } from 'cva';
import Image from 'next/image';
import React, { Fragment, Suspense, use, useState } from 'react';
import SmallCardedSkeleton from './SmallCardedSkeleton';
import TopContributorsDialog from './home-page-dialogs/TopContributorsDialog';
import { getJobTitle } from '@/utils/user.helper';

function TopChangeMakers(props) {
  const {
    changeMakersPromise,
    className,
    variant = 'elevated',
    padding = 'md',
    viewAll = false,
  } = props;
  const users = use(changeMakersPromise);
  const [showAll, setShowAll] = useState(false);

  if (!users || !users.length) {
    return null;
  }

  const getUserProfileSlug = (user) => {
    return user.slug ? `/${user.slug}` : null;
  };

  return (
    <Suspense
      fallback={
        <SmallCardedSkeleton variant={variant} title="Top Change Makers" />
      }>
      <Card
        className={cx('gap-6', className)}
        variant={variant}
        padding={padding}>
        <div className="grid w-full grid-cols-3">
          <div className="col-span-2">
            <Typography variant="h3" component="h2">
              Top Change Makers
            </Typography>
          </div>

          {viewAll && (
            <button
              type="button"
              className="text-12 text-text-hyperlink"
              onClick={() => setShowAll(true)}>
              View All
            </button>
          )}
        </div>
        <div className="grid grid-cols-3 gap-y-6">
          {users.map((user) => (
            <Fragment key={user.id}>
              <div className="col-span-2 flex items-center justify-start gap-4">
                <Avatar
                  src={getQualifiedImageUrl(user.avatar)}
                  alt={user.first_name}
                />
                <div className="flex flex-col items-start justify-between">
                  <Link href={getUserProfileSlug(user)}>
                    <Typography
                      variant="subtitle1"
                      className="group-hover:text-text-hyperlink">
                      {user.first_name} {user.last_name}
                    </Typography>
                  </Link>
                  <Typography variant="body1" color="textSecondary">
                    {getJobTitle(user)}
                  </Typography>
                </div>
              </div>
              <div className="flex items-center justify-center">
                <Image
                  width={55}
                  height={33}
                  src={getQualifiedImageUrl(user?.level?.imageUrl) || ''}
                  className="h-8 w-14 object-contain"
                  alt="user neki level"
                />
              </div>
            </Fragment>
          ))}
        </div>

        {showAll && (
          <TopContributorsDialog
            open={showAll}
            title="Change Makers"
            onClose={() => setShowAll(false)}
          />
        )}
      </Card>
    </Suspense>
  );
}

export default React.memo(TopChangeMakers);
